var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sol_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__b)",
    stroke: "url(#sol_svg__c)",
    strokeWidth: 0.328,
    d: "M2.684 9.03c.03-.03.073-.05.119-.05h8.115l.001.001v.001l.001.001v.001l-1.604 1.604.116.116-.116-.117a.168.168 0 0 1-.119.05H1.081l-.001-.002v-.002L2.685 9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__d)",
    d: "M2.568 2.929a.342.342 0 0 1 .235-.097h8.115c.148 0 .222.179.117.284L9.432 4.719a.333.333 0 0 1-.235.097H1.082a.166.166 0 0 1-.118-.284l1.604-1.603Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#sol_svg__e)",
    strokeOpacity: 0.5,
    strokeWidth: 0.328,
    d: "m1.08 4.648 1.602-1.602a.178.178 0 0 1 .12-.05H10.92v.001L10.92 3 9.315 4.604a.169.169 0 0 1-.119.049H1.081a.007.007 0 0 1-.001-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sol_svg__f)",
    stroke: "url(#sol_svg__g)",
    strokeWidth: 0.328,
    d: "M9.197 5.969c.046 0 .088.018.12.05l.115-.117-.116.116 1.603 1.603.001.001v.003H2.802a.169.169 0 0 1-.12-.05L1.082 5.974l-.001-.001V5.97l.002-.001h8.115Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__b",
    x1: 10.143,
    x2: 4.526,
    y1: 1.874,
    y2: 12.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__c",
    x1: 0.915,
    x2: 11.084,
    y1: 9.809,
    y2: 9.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF59F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91B4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__d",
    x1: 7.687,
    x2: 2.071,
    y1: 0.592,
    y2: 11.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__e",
    x1: 0.915,
    x2: 11.084,
    y1: 3.824,
    y2: 3.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#67C9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17F3C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__f",
    x1: 8.907,
    x2: 3.291,
    y1: 1.229,
    y2: 11.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__g",
    x1: 0.915,
    x2: 11.084,
    y1: 6.797,
    y2: 6.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B293E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC6D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sol_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.916 2.832h10.168V10.8H.916z"
  })))));
};
export default SvgSol;